var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"onboarding-paragraph"},[_vm._v("\n    Remember that you must prioritize your goals according to the most important goal at that time. One completed goal is better than five goals that you never achieve.\n  ")])])
}]

export { render, staticRenderFns }